// src/data/activitiesData.js

// Import activity images
import KrushiMandiImage from '../assets/krushi.JPG';
import EnvironmentImage from '../assets/env.JPG';
import FloodReliefImage from '../assets/dadaSaheb.jpg';
import HealthImage from '../assets/vibhag-logos/ayurved-vibhag.png';
import RiverCleanImage from '../assets/Nadi.JPG';


export const activitiesData = {
  mr: [
    {
      id: 1,
      title: "कृषी मांदियाळी",
      date: "सतत कार्यक्रम",
      thumbnail: KrushiMandiImage,
      description: "कृषी मांदियाळी म्हणजे कृषी प्रतिनिधी व शेतकरी यांनी एकत्रित येऊन केलेली चर्चा तथा संवाद होय.",
      fullContent: `
        <h3>🌾 कृषी मांदियाळी</h3>
        <ul>
          <li>कृषीशास्त्र विभाग अंतर्गत कृषी मांदियाळीचे नियोजन केले जाते.</li>
          <li>कृषी मांदियाळी म्हणजे कृषी प्रतिनिधी व शेतकरी यांनी एकत्रित येऊन केलेली चर्चा तथा संवाद होय.</li>
          <li>कृषी मांदियाळीत उपस्थित शेतकऱ्यांकडून शेताच्या बांधावर वृक्षारोपण केले जाते.</li>
          <li>यामुळे पिकांचे पशूंमुळे होणारे नुकसान थांबते व उपन्नात वाढ होते.</li>
          <li>शेतकऱ्यांना शेतीविषयक विविध विषयांवर विनामूल्य मार्गदर्शन केले जाते.</li>
          <li>शेतीला उपयुक्त मोफत गोकृपामृत व कल्चर वाटप केले जाते.</li>
          <li>विषमुक्त शेती कशी करावी, विषमुक्त अन्न कसे मिळेल? इत्यादी विषयांवर प्रबोधन केले जाते.</li>
          <li>गरजू शेतकऱ्यांना शाकंभरी सीड बँक अंतर्गत मोफत बियाणे वाटप केले जाते.</li>
          <li>मराठवाडा, विदर्भ, पश्चिम महाराष्ट्र, खान्देश, उत्तर महाराष्ट्र व कोकण विभागातील अनेक जिल्ह्यात कृषी मांदियाळी झाल्या आहेत.</li>
        </ul>
        <p><strong>🎯 पुढील कार्यक्रम:</strong> बुलढाणा व नाशिक जिल्ह्यात कृषी मांदियाळीचे नियोजन</p>
        <p><strong>📅 जागतिक कृषी महोत्सव:</strong> 23 ते 27 जानेवारी 2026, युथ फेस्टिवल मैदान, नाशिक</p>
      `,
      photos: [KrushiMandiImage],
      videos: [
        {
          title: "कृषी मांदियाळी हायलाइट्स",
          url: "https://www.youtube.com/embed/yourVideoID1"
        }
      ],
      location: "महाराष्ट्रातील विविध जिल्हे"
    },
    {
      id: 2,
      title: "पर्यावरणपूरक जीवनशैली व प्लेट बँक",
      date: "सतत उपक्रम",
      thumbnail: EnvironmentImage,
      description: "पर्यावरण संरक्षणासाठी पर्यावरणपूरक उत्पादने व प्लेट बँक संकल्पना.",
      fullContent: `
        <h3>🌿 पर्यावरणपूरक जीवनशैली</h3>
        <ul>
          <li>आपण आपली जीवनशैली पर्यावरण पूरक केली तर आपले आरोग्य चांगले राहील व पर्यावरणाचे संरक्षण होईल.</li>
          <li>रोजच्या वापरातील वस्तू: चमचा, छोटा ग्लास, पाण्याची बाटली, टूथपेस्ट, ब्रश, चप्पल इत्यादी.</li>
          <li>कापडी पिशवी - प्लॅस्टीक पिशवी ऐवजी दैनिक वापरासाठी.</li>
        </ul>
        
        <h3>🍽️ प्लेट बँक</h3>
        <ul>
          <li>प्लॅस्टीकचा वापर कमी करण्यासाठी 'प्लेट बँक' संकल्पना सुरू.</li>
          <li>महाराष्ट्रातील प्रत्येक जिल्ह्यात व परराज्यात प्लेट बँक सुरू.</li>
          <li>छोटे-मोठे कार्यक्रमात प्लेट बँकेचा गरजूंना मोठा फायदा.</li>
          <li>पत्रवाळी व डिश खर्चात बचत.</li>
        </ul>

        <h3>🌳 पर्यावरण संरक्षण</h3>
        <ul>
          <li>शेतीचा बांध सजीव राहावा व उत्पन्न वाढावे यासाठी वृक्षारोपण.</li>
          <li>दरवर्षी जुलै-ऑगस्ट महिन्यात शेतकऱ्यांच्या बांधावर झाडे लावून जगवली जातात.</li>
        </ul>
      `,
      photos: [EnvironmentImage],
      videos: ["https://www.youtube.com/embed/yFeuCFwWmQs?si=eOaqXPQ2MEoLuPOn"],
      location: "महाराष्ट्र व परराज्य"
    },
    {
      id: 3,
      title: "अतिवृष्टीग्रस्त शेतकऱ्यांना मदत",
      date: "आपत्कालीन सहाय्य कार्यक्रम",
      thumbnail: FloodReliefImage,
      description: "अतिवृष्टीमुळे बाधित शेतकऱ्यांना आर्थिक व भावनिक मदत.",
      fullContent: `
        <h3>🌧️ अतिवृष्टीमुळे बाधित शेतकऱ्यांना सहकार्य</h3>
        <ul>
          <li>विविध जिल्ह्यात अतिवृष्टीमुळे पीक व पशुधन नुकसान झालेल्या शेतकऱ्यांना मदत.</li>
          <li>श्री स्वामी समर्थ सेवा मार्गाच्या वतीने योग्य ती मदत पाठवली जात आहे.</li>
          <li>शेतकऱ्यांना समुपदेशन करून धीर दिला जात आहे.</li>
          <li>परमपूज्य गुरुमाऊलीच्या आशिर्वाद व मार्गदर्शनानुसार आवश्यक मदत.</li>
          <li>सेवेकऱ्यांकडून दिवाळीनिमित्त फराळ वाटप.</li>
          <li><strong>विशेष:</strong> नुकसान झालेल्या शेतकऱ्यांच्या मुलामुलींचे जागतिक कृषी महोत्सव 2026 मध्ये मोफत सामूहिक विवाह.</li>
        </ul>
      `,
      photos: [FloodReliefImage],
      videos: [
        {
          title: "शेतकरी मदत कार्यक्रम",
          url: "https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Freel%2F25565272363076213%2F&show_text=false&width=267&t=0"
        }
      ],
      location: "महाराष्ट्रातील बाधित जिल्हे"
    },
    {
      id: 4,
      title: "आरोग्य व आयुर्वेद विभाग",
      date: "मासिक आरोग्य शिबिरे",
      thumbnail: HealthImage,
      description: "आर्थिकदृष्ट्या दुर्बल घटकांसाठी मोफत आरोग्य सेवा व रुग्णालय निर्मिती.",
      fullContent: `
        <h3>🏥 आरोग्य व आयुर्वेद विभाग</h3>
        <ul>
          <li>समाजातील आर्थिक दुर्बल घटकातील सदस्यांचे आरोग्य उत्तम राहावे यासाठी कार्य.</li>
          <li>नाशिक जिल्ह्यात आदिवासी भागातील विविध पाड्यांवर मोफत औषधे वाटप सुरू.</li>
          <li>प्रति महिना विविध ठिकाणी मोफत आरोग्य तपासणी.</li>
          <li>मोफत नाडी परीक्षण शिबीर सुरू.</li>
          <li><strong>जनकल्याण योजना:</strong> सद्गुरू मोरेदादा मल्टी स्पेशालिटी चॅरिटेबल हॉस्पिटलची निर्मिती होत आहे.</li>
          <li>परमपूज्य गुरूमाऊलींच्या आशिर्वादाने गोर-गरिबांसाठी सेवा.</li>
        </ul>
      `,
      photos: [HealthImage],
      videos: [
        {
          title: "आरोग्य शिबिर कार्यक्रम",
          url: "https://www.youtube.com/embed/f3Mqvxasec0?si=ySCKogSvOpxzV3kR"
        }
      ],
      location: "नाशिक जिल्हा व आजूबाजूचे क्षेत्र"
    },
    {
      id: 5,
      title: "नदी स्वच्छता अभियान",
      date: "प्रतिमाह अभियान",
      thumbnail: RiverCleanImage,
      description: "गोदावरी नदी व तीर्थक्षेत्रांची स्वच्छता मोहीम.",
      fullContent: `
        <h3>🌊 नदी स्वच्छता अभियान</h3>
        <ul>
          <li>शेती, मानव व सर्व सजीवांना पुरेसे पाणी मिळावे यासाठी नदी स्वच्छता अभियान.</li>
          <li>प्रतिमहिना राबविले जाणारे स्वच्छता अभियान.</li>
        </ul>

        <h3>📍 स्वच्छता स्थळे:</h3>
        <ul>
          <li><strong>पंचवटी, नाशिक:</strong> रामकुंड व संपूर्ण गोदाघाट परिसर - प्रतिमाह</li>
          <li><strong>त्र्यंबकेश्वर:</strong> कुशावर्त तीर्थ व परिसर - प्रतिमाह चौथ्या शनिवारी</li>
          <li><strong>मंदिर संवर्धन:</strong> मंदिर, गड, किल्ले व दुर्ग स्वच्छता अभियान</li>
        </ul>

        <h3>🎯 उद्देश:</h3>
        <ul>
          <li>नद्यांचे संरक्षण व स्वच्छता</li>
          <li>तीर्थक्षेत्रांचे संवर्धन</li>
          <li>ऐतिहासिक वारसा जतन</li>
          <li>जनजागृती व सहभाग</li>
        </ul>
      `,
      photos: [RiverCleanImage],
      videos: [
        {
          title: "नदी स्वच्छता अभियान",
          url: "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fdindoripranit%2Fvideos%2F861959781904400%2F&show_text=false&width=560&t=0"
        }
      ],
      location: "नाशिक - पंचवटी व त्र्यंबकेश्वर"
    },
    
  ],
  en: [
    {
      id: 1,
      title: "Agricultural Gatherings (Krushi Mandiyali)",
      date: "Ongoing Program",
      thumbnail: KrushiMandiImage,
      description: "Agricultural gatherings where farmers and agricultural representatives come together for dialogue and knowledge sharing.",
      fullContent: `
        <h3>🌾 Agricultural Gatherings (Krushi Mandiyali)</h3>
        <ul>
          <li>Agricultural gatherings organized under the Agriculture Department.</li>
          <li>Platform for farmers and agricultural representatives to discuss and exchange ideas.</li>
          <li>Tree plantation on farm boundaries by participating farmers.</li>
          <li>Helps prevent crop damage from livestock and increases income.</li>
          <li>Free guidance on various agricultural topics for farmers.</li>
          <li>Free distribution of beneficial agricultural products like Gokrupamrut and cultures.</li>
          <li>Education on poison-free farming and organic food production.</li>
          <li>Free training for agricultural representatives on soil testing, water testing, and seed testing.</li>
          <li>Free seed distribution to needy farmers through Shakambhari Seed Bank.</li>
          <li>Gatherings conducted across Marathwada, Vidarbha, Western Maharashtra, Khandesh, North Maharashtra, and Konkan regions.</li>
        </ul>
        <p><strong>🎯 Upcoming Programs:</strong> Agricultural gatherings planned in Buldhana and Nashik districts</p>
        <p><strong>📅 Global Agriculture Festival:</strong> January 23-27, 2026, Youth Festival Ground, Nashik</p>
      `,
      photos: [KrushiMandiImage],
      videos: [
        {
          title: "Agricultural Gathering Highlights",
          url: "https://www.youtube.com/embed/yourVideoID1"
        }
      ],
      location: "Various districts across Maharashtra"
    },
    {
      id: 2,
      title: "Environment-Friendly Lifestyle & Plate Bank",
      date: "Continuous Initiative",
      thumbnail: EnvironmentImage,
      description: "Environment-friendly products and Plate Bank concept for environmental protection.",
      fullContent: `
        <h3>🌿 Environment-Friendly Lifestyle</h3>
        <ul>
          <li>Adopting an eco-friendly lifestyle ensures better health and environmental protection.</li>
          <li>Daily use eco-friendly items: spoons, small glasses, water bottles, toothpaste, brushes, slippers, etc.</li>
          <li>Cloth bags as alternatives to plastic bags for daily use.</li>
        </ul>
        
        <h3>🍽️ Plate Bank</h3>
        <ul>
          <li>'Plate Bank' concept launched to reduce plastic usage.</li>
          <li>Plate Banks operational in every district of Maharashtra and other states.</li>
          <li>Great benefit for small and large events - saves costs on disposables.</li>
          <li>Savings on disposable plates and dishes.</li>
        </ul>

        <h3>🌳 Environmental Conservation</h3>
        <ul>
          <li>Tree plantation to keep farm boundaries alive and increase agricultural income.</li>
          <li>Annual tree planting drives during July-August on farmers' field boundaries.</li>
        </ul>
      `,
      photos: [EnvironmentImage],
      videos: [],
      location: "Maharashtra and other states"
    },
    {
      id: 3,
      title: "Flood-Affected Farmers Relief",
      date: "Emergency Assistance Program",
      thumbnail: FloodReliefImage,
      description: "Financial and emotional support to farmers affected by excessive rainfall.",
      fullContent: `
        <h3>🌧️ Support for Flood-Affected Farmers</h3>
        <ul>
          <li>Assistance to farmers whose crops and livestock were damaged due to excessive rainfall in various districts.</li>
          <li>Appropriate aid sent on behalf of Shri Swami Samarth Seva Marg.</li>
          <li>Counseling and moral support provided to affected farmers.</li>
          <li>Essential help sent as per the blessings and guidance of Param Pujya Gurumauli.</li>
          <li>Distribution of festive snacks to farmers on the occasion of Diwali.</li>
          <li><strong>Special Initiative:</strong> Free mass weddings for children of affected farmers at Global Agriculture Festival 2026.</li>
        </ul>
      `,
      photos: [FloodReliefImage],
      videos: [
        {
          title: "Farmer Relief Program",
          url: "https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Freel%2F25565272363076213%2F&show_text=false&width=267&t=0"
        }
      ],
      location: "Affected districts across Maharashtra"
    },
    {
      id: 4,
      title: "Health & Ayurveda Department",
      date: "Monthly Health Camps",
      thumbnail: HealthImage,
      description: "Free healthcare services and hospital establishment for economically disadvantaged sections.",
      fullContent: `
        <h3>🏥 Health & Ayurveda Department</h3>
        <ul>
          <li>Working to ensure excellent health for economically disadvantaged community members.</li>
          <li>Free medicine distribution ongoing in various tribal hamlets in Nashik district.</li>
          <li>Monthly free health check-up camps at various locations.</li>
          <li>Free pulse diagnosis (Nadi Parikshan) camps operational.</li>
          <li><strong>Jan Kalyan Yojana:</strong> Sadguru Moredada Multi-Specialty Charitable Hospital under construction.</li>
          <li>Services for the poor and underprivileged with blessings of Param Pujya Gurumauli.</li>
        </ul>
      `,
      photos: [HealthImage],
      videos: [
        {
          title: "Health Camp Programs",
          url: "https://www.youtube.com/embed/f3Mqvxasec0?si=ySCKogSvOpxzV3kR"
        }
      ],
      location: "Nashik District and surrounding areas"
    },
    {
      id: 5,
      title: "River Cleanliness Campaign",
      date: "Monthly Drive",
      thumbnail: RiverCleanImage,
      description: "Cleanliness campaign for River Godavari and pilgrimage sites.",
      fullContent: `
        <h3>🌊 River Cleanliness Campaign</h3>
        <ul>
          <li>River cleanliness campaign to ensure adequate water for agriculture, human use, and all living beings.</li>
          <li>Monthly cleanliness drives conducted regularly.</li>
        </ul>

        <h3>📍 Cleanliness Locations:</h3>
        <ul>
          <li><strong>Panchavati, Nashik:</strong> Ramkund and entire Godaghat area - Monthly</li>
          <li><strong>Trimbakeshwar:</strong> Kushavarta Tirtha and surrounding area - Every fourth Saturday</li>
          <li><strong>Heritage Conservation:</strong> Cleanliness campaigns at temples, forts, and historic monuments</li>
        </ul>

        <h3>🎯 Objectives:</h3>
        <ul>
          <li>Protection and cleanliness of rivers</li>
          <li>Conservation of pilgrimage sites</li>
          <li>Preservation of historical heritage</li>
          <li>Public awareness and participation</li>
        </ul>
      `,
      photos: [RiverCleanImage],
      videos: [
        {
          title: "River Cleanliness Drive",
          url: "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fdindoripranit%2Fvideos%2F861959781904400%2F&show_text=false&width=560&t=0"
        }
      ],
      location: "Nashik - Panchavati and Trimbakeshwar"
    },
    
  ]
};